import { TextInput } from '../baseInputs'

type Props = {
  helper?: string
  optional?: boolean
}

const MembershipNo = ({ helper, optional, ...rest }: Props) => {
  const name = 'urn'
  const label = 'Membership number'

  return (
    <TextInput
      name={name}
      label={label}
      helper={helper}
      optional={optional}
      {...rest}
    />
  )
}

export default MembershipNo
